// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__mVIYM","searchInput":"Search_searchInput__JV0cW","icon":"Search_icon__XMmYc","hint":"Search_hint__1Fq-I"};